export const EvaluationPerformancePhase = {
    path: '/evaluation_performance_phases',
    name: 'evaluation_performance_phases',
    component: () => import('@/views/Evaluation/Phase/EvaluationPerformancePhasePage.vue'),
    props: {type: 'EVALUATION_PERFORMANCE'},
    children: [
        {
            path: '/evaluation_performance_phases/add',
            name: 'evaluation_performance_phases.add',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {addAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_phases/edit/:id',
            name: 'evaluation_performance_phases.edit',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {updateAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_phase/delete/:id',
            name: 'evaluation_performance_phases.delete',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {deleteAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
        {
            path: '/evaluation_performance_phases/view/:id',
            name: 'evaluation_performance_phases.view',
            component: () => import('@/views/Evaluation/Phase/Form/EvaluationPhaseForm.vue'),
            props: {viewAction: true, type: 'EVALUATION_PERFORMANCE'}
        },
    ]
}